module.exports = __webpack_public_path__ + "static/media/contact-header-image-crop.360acc3a.jpeg";